import {
  IconCalendarEvent,
  IconCreditCard,
  IconFileInvoice,
  IconGitMerge,
  IconLayoutDashboardFilled,
  IconLock,
  IconMilitaryRank,
  IconMoneybag,
  IconReport,
  IconReportAnalytics,
  IconSettings,
  IconSettings2,
  IconShield,
  IconShoppingCart,
  IconTags,
  IconUsers,
  IconUsersGroup,
  IconTool,
  IconPackage,
  IconPrinter,
  IconBuildingStore,
  IconFileText,
  IconReceipt,
} from "@tabler/icons-react";

const apiUrl = process.env.REACT_APP_API_URL;

const API_VERSION = "v1";
export const API_URL = apiUrl + API_VERSION;

const VERSION_V1 = "/v1";

export const LIMIT_DATA_PER_PAGE = 20;

export const DISCOUNT_TYPES = [
  { value: "fixed", label: "Fixed" },
  { value: "percentage", label: "Percentage" },
];

export const RECURRING_TYPES = [
  { value: "daily", label: "Daily" },
  { value: "weekly", label: "Weekly" },
  { value: "monthly", label: "Monthly" },
  { value: "yearly", label: "Yearly" },
];

export const ACTION_TYPES = {
  CREATE: "Create",
  EDIT: "Edit",
  VIEW: "View",
};

export const URLS = {
  ROOT: "/",
  INVOICES_PUBLIC_VIEW: `/invoice/view/:invoice_number`,
  v1: {
    // DASHBOARD
    DASHBOARD: `${VERSION_V1}/`,
    NOTAUTHORIZED: `${VERSION_V1}/not-authorized`,

    // ACCOUNTING
    ACCOUNTING: `${VERSION_V1}/accounting`,
    ACCOUNTING_BACKUP: `${VERSION_V1}/accounting-backup`,
    ACCOUNTINGV2: `${VERSION_V1}/accounting-v2`,
    ACCOUNTING_BOOKKEEPING: `${VERSION_V1}/accounting/bookkeeping`,
    ACCOUNTING_FB_DAILY_RECAP: `${VERSION_V1}/accounting/fb-daily-recap`,
    KEEP_LIST: `${VERSION_V1}/accounting-keep`,
    MASTER_KEEP: `${VERSION_V1}/master-keep`,

    // URLS
    CUSTOMERS: `${VERSION_V1}/customers`,
    INVOICES: `${VERSION_V1}/invoices`,
    INVOICES_CREATE: `${VERSION_V1}/invoices/create`,
    INVOICES_VIEW: `${VERSION_V1}/invoices/:id/view`,
    INVOICES_EDIT: `${VERSION_V1}/invoices/:id/edit`,
    INVOICES_HISTORY: `${VERSION_V1}/invoices/history`,
    INVOICES_HISTORY_BY_ID: `${VERSION_V1}/invoices/history/:id`,
    DISCOUNT: `${VERSION_V1}/discounts`,
    DISCOUNT_CREATE: `${VERSION_V1}/discounts/create`,
    DISCOUNT_EDIT: `${VERSION_V1}/discounts/:id/edit`,

    // USER SETTINGS
    TEAMS: `${VERSION_V1}/teams`,
    ROLES: `${VERSION_V1}/roles`,
    PERMISSIONS: `${VERSION_V1}/permissions`,
    PROFILE: `${VERSION_V1}/profile`,
    CHANGE_PASSWORD: `${VERSION_V1}/change-password`,

    // SYSTEM SETTINGS
    SYSTEM_SETTING: `${VERSION_V1}/system-settings`,
    GENERAL: `${VERSION_V1}/system-settings/general`,
    NOTIF_CHANNEL: `${VERSION_V1}/system-settings/notif-channel`,
    PAYMENT_GATEWAY: `${VERSION_V1}/system-settings/payment-gateway`,
    BANK_ACCOUNT: `${VERSION_V1}/system-settings/bank-account`,
    TEMPLATE_MESSAGE: `${VERSION_V1}/system-settings/template-message`,
    PENGATURAN_APLIKASI: `${VERSION_V1}/system-settings/pengaturan-aplikasi`,

    // AUTH
    LOGIN: `${VERSION_V1}/login`,
    SIGN_UP: `${VERSION_V1}/sign-up`,

    // BOOKING
    BOOKING: `${VERSION_V1}/booking`,
    BOOKINGV2: `${VERSION_V1}/booking/v2`,
    BOOKINGV3: `${VERSION_V1}/booking/v3`,
    BOOKINGV4: `${VERSION_V1}/booking/v4`,
    BOOKINGV4_PRINT_LAYOUT: `${VERSION_V1}/booking/v4/print-layout-settings`,
    BOOKINGREPORT: `${VERSION_V1}/booking-report`,
    KOMISIAGENT: `${VERSION_V1}/komisi-agent`,
    LAPORANBOOKING: `${VERSION_V1}/laporan-booking`,
    LAPORANPRODUK: `${VERSION_V1}/laporan-produk`,
    LAPORANPEMBAYARAN: `${VERSION_V1}/laporan-pembayaran`,
    DAILYREPORT: `${VERSION_V1}/daily-report`,

    // AGENT RANK
    AGENTRANK: `${VERSION_V1}/agent-rank`,
    AGENTRANK_REWARD: `${VERSION_V1}/agent-rank/reward`,
    AGENTRANK_REWARD_CRUD: `${VERSION_V1}/agent-rank/reward-crud`,
    AGENTRANK_PINALTY: `${VERSION_V1}/agent-rank/pinalty`,
    AGENTRANK_SETTING: `${VERSION_V1}/agent-rank/setting`,

    // WORKSHOP
    WORKSHOP: `${VERSION_V1}/workshop`,
    WORKSHOP_TUTORIAL: `${VERSION_V1}/workshop/tutorial`,
    WORKSHOP_INVENTORY: `${VERSION_V1}/workshop/inventory`,
    WORKSHOP_SUPPLIER: `${VERSION_V1}/workshop/suppliers`,
    WORKSHOP_PURCHASE_ORDERS: `${VERSION_V1}/workshop/purchase-orders`,
    WORKSHOP_PURCHASE_RECEIPTS: `${VERSION_V1}/workshop/purchase-receipts`,
    WORKSHOP_SERVICE_REPORTS: `${VERSION_V1}/workshop/service-reports`,
    WORKSHOP_STOCK_TRANSFERS: `${VERSION_V1}/workshop/stock-transfers`,

    // HR
    HR_HOME: `${VERSION_V1}/hr`,
    HR_TUTORIAL: `${VERSION_V1}/hr/tutorial`,
    HR_MANAGE: `${VERSION_V1}/hr/manage`,
    HR_MANAGE_USER: `${VERSION_V1}/hr/manage/user`,
    HR_MANAGE_STAFF_DETAIL: `${VERSION_V1}/hr/manage/staff-detail`,
    HR_MANAGE_TEAM: `${VERSION_V1}/hr/manage/team`,
    HR_MANAGE_IDCARD: `${VERSION_V1}/hr/manage/idcard`,
    HR_MANAGE_ATTENDANCE: `${VERSION_V1}/hr/manage/attendance`,
    HR_MANAGE_ATTENDANCE_RECAP: `${VERSION_V1}/hr/manage/attendance-recap`,
    HR_MANAGE_PUBLIC_HOLIDAY_QUOTA: `${VERSION_V1}/hr/manage/public-holiday-quota`,
    HR_MANAGE_PUBLIC_HOLIDAY_USE: `${VERSION_V1}/hr/manage/public-holiday-use`,
    HR_MANAGE_SALARY: `${VERSION_V1}/hr/manage/salary`,
    HR_MANAGE_STAFF_LOAN: `${VERSION_V1}/hr/manage/staff-loans`,
    HR_MANAGE_SCHEDULE: `${VERSION_V1}/hr/manage/schedule`,
    HR_MANAGE_SCHEDULE_PATTERNS: `${VERSION_V1}/hr/manage/schedule-patterns`,
    HR_MANAGE_TIME_OFF_REQUESTS: `${VERSION_V1}/hr/manage/time-off-requests`,
    HR_MANAGE_OVERTIME_REQUESTS: `${VERSION_V1}/hr/manage/overtime-requests`,
    HR_MANAGE_TRANSACTIONS: `${VERSION_V1}/hr/manage/transactions`,
    HR_MASTER: `${VERSION_V1}/hr/master`,
    HR_MASTER_ASSET_GROUP: `${VERSION_V1}/hr/master/asset-group`,
    HR_MASTER_ASSET_ITEM: `${VERSION_V1}/hr/master/asset-item`,
    HR_MASTER_VENDOR: `${VERSION_V1}/hr/master/vendor`,
    HR_MASTER_BANK_ACCOUNT: `${VERSION_V1}/hr/master/bank-account`,
    HR_MASTER_INSURANCE: `${VERSION_V1}/hr/master/insurance`,
    HR_MASTER_FACILITY: `${VERSION_V1}/hr/master/facility`,
    HR_MASTER_DEDUCTION: `${VERSION_V1}/hr/master/deduction`,
    HR_MASTER_DEPARTMENTS: `${VERSION_V1}/hr/master/departments`,
    HR_MASTER_POSITIONS: `${VERSION_V1}/hr/master/positions`,
    HR_MASTER_SHIFTS: `${VERSION_V1}/hr/master/shifts`,
    HR_MASTER_OFFICE: `${VERSION_V1}/hr/master/office`,
    HR_MASTER_HOLIDAYS: `${VERSION_V1}/hr/master/holidays`,
    HR_MASTER_APPROVAL_LINES: `${VERSION_V1}/hr/master/approval-lines`,
    HR_MASTER_TIME_OFF_POLICIES: `${VERSION_V1}/hr/master/time-off-policies`,
    HR_MASTER_OVERTIME_POLICIES: `${VERSION_V1}/hr/master/overtime-policies`,
    HR_SETTING: `${VERSION_V1}/hr/setting`,
    HR_SETTING_ATTENDANCE: `${VERSION_V1}/hr/setting/attendance`,
    HR_SETTING_SALARY: `${VERSION_V1}/hr/setting/salary`,
    HR_REPORT: `${VERSION_V1}/hr/report`,
    HR_REPORT_FINANCE: `${VERSION_V1}/hr/report/finance`,
    HR_REPORT_ASSET: `${VERSION_V1}/hr/report/asset`,
    HR_REPORT_ATTENDANCE: `${VERSION_V1}/hr/report/attendance`,
    HR_REPORT_SALARY: `${VERSION_V1}/hr/report/salary`,
    HR_REPORT_SETTLEMENT: `${VERSION_V1}/hr/report/settlement`,

    // MASTERDATA
    AGENTS: `${VERSION_V1}/agents`,
    AGENT_HISTORY: `${VERSION_V1}/agents/:id/history`,
    LABELS: `${VERSION_V1}/labels`,
    PRODUCT: `${VERSION_V1}/products`,
    PRODUCT_CREATE: `${VERSION_V1}/products/create`,
    METODE_PEMBAYARAN: `${VERSION_V1}/metode-pembayaran`,
    TRIP: `${VERSION_V1}/trips`,
    GUIDE: `${VERSION_V1}/guide`,
    USER: `${VERSION_V1}/users`,
    PHOTOGRAPHER: `${VERSION_V1}/photographers`,
    MEAL: `${VERSION_V1}/meals`,
    WAREHOUSES: `/warehouses`,

    // RESTO
    ORDERS: `${VERSION_V1}/orders`,
    POS: `${VERSION_V1}/pos`,
    TRANSACTIONS_HISTORY: `${VERSION_V1}/transactions-history`,
    REFUNDS: `${VERSION_V1}/refunds`,
    PRODUCT_RESTO: `${VERSION_V1}/products-resto`,
    STOCK_RESTO: `${VERSION_V1}/stock-resto`,
    SUPPLIER: `${VERSION_V1}/suppliers`,
    CASHIERHISTORY: `${VERSION_V1}/CashierHistory`,
    DAILYREPORTRESTO: `${VERSION_V1}/daily-report-resto`,
  },
  v2: {},
};

export const NAV_LINKS = [
  {
    name: "Dashboard",
    href: URLS.v1.DASHBOARD,
    icon: IconLayoutDashboardFilled,
    roles: ["superadmin", "admin"], // Semua role bisa melihat
  },
  {
    name: "Accounting",
    icon: IconLayoutDashboardFilled,
    roles: ["superadmin", "accounting"], // Semua role bisa melihat
    child: [
      {
        name: "Accounting V2",
        href: URLS.v1.ACCOUNTINGV2,
        icon: IconLayoutDashboardFilled,
        roles: ["superadmin", "accounting"],
      },
      {
        name: "Pembukuan",
        href: URLS.v1.ACCOUNTING_BOOKKEEPING,
        icon: IconReceipt,
        roles: ["superadmin", "accounting"],
      },
      {
        name: "F&B Daily Recap",
        href: URLS.v1.ACCOUNTING_FB_DAILY_RECAP,
        icon: IconReceipt,
        roles: ["superadmin", "accounting"],
      },
      {
        name: "Data Keep",
        href: URLS.v1.KEEP_LIST,
        icon: IconFileText,
        roles: ["superadmin", "accounting"],
      }
    ]
  },
  {
    name: "Transaksi",
    icon: IconCalendarEvent,
    roles: ["superadmin", "admin", "host", "reservation"], // Semua role bisa melihat menu Transaksi
    child: [
      {
        name: "Booking",
        href: URLS.v1.BOOKINGV3,
        icon: IconCalendarEvent,
        roles: ["superadmin", "admin", "host", "reservation"],
      },
      {
        name: "Booking V4",
        href: URLS.v1.BOOKINGV4,
        icon: IconCalendarEvent,
        roles: ["superadmin", "Lead Host", "host"],
      },
      {
        name: "Print Layout Settings",
        href: URLS.v1.BOOKINGV4_PRINT_LAYOUT,
        icon: IconPrinter,
        roles: ["superadmin", "admin"],
      },
      {
        name: "Booking Report",
        href: URLS.v1.BOOKINGREPORT,
        icon: IconReport,
        roles: ["superadmin", "admin"],
      },
      {
        name: "Daily Report",
        href: URLS.v1.DAILYREPORT,
        icon: IconReport,
        roles: ["superadmin", "admin"],
      },
      {
        name: "Susuk Agent",
        href: URLS.v1.KOMISIAGENT,
        icon: IconMoneybag,
        roles: ["superadmin", "admin", "susuk"],
      },
    ],
  },
  // Agent Rank
  {
    name: "Agent Rank",
    // href: URLS.v1.AGENTRANK,
    icon: IconMilitaryRank,
    roles: ["superadmin"], // Hanya Super Admin dan Admin yang bisa melihat
    child: [
      {
        name: "Rank",
        href: URLS.v1.AGENTRANK,
        icon: IconMilitaryRank,
        roles: ["superadmin"],
      },
      // {
      //   name: "Reward",
      //   href: URLS.v1.AGENTRANK_REWARD,
      //   icon: IconMoneybag,
      //   roles: ["superadmin"],
      // },
      {
        name: "Reward Management",
        href: URLS.v1.AGENTRANK_REWARD_CRUD,
        icon: IconSettings2,
        roles: ["superadmin"],
      },
      {
        name: "Pinalty",
        href: URLS.v1.AGENTRANK_PINALTY,
        icon: IconLock,
        roles: ["superadmin"],
      },
      {
        name: "Setting",
        href: URLS.v1.AGENTRANK_SETTING,
        icon: IconSettings,
        roles: ["superadmin"],
      },
    ],
  },
  // Workshop
  {
    name: "Workshop",
    // href: URLS.v1.WORKSHOP,
    icon: IconTool,
    roles: ["superadmin", "mekanik", "admin_mekanik"], // Hanya Super Admin dan Admin yang bisa melihat
    child: [
      {
        name: "Mekanik",
        href: URLS.v1.WORKSHOP,
        icon: IconTool,
        roles: ["superadmin", "mekanik"],
      },
      {
        name: "Tutorial",
        href: URLS.v1.WORKSHOP_TUTORIAL,
        icon: IconFileText,
        roles: ["superadmin", "mekanik", "admin_mekanik"],
      },
      {
        name: "Inventory",
        href: URLS.v1.WORKSHOP_INVENTORY,
        icon: IconPackage,
        roles: ["superadmin", "admin_mekanik"],
      },
      {
        name: "Supplier",
        href: URLS.v1.WORKSHOP_SUPPLIER,
        icon: IconBuildingStore,
        roles: ["superadmin", "admin_mekanik"],
      },
      {
        name: "Purchase Orders",
        href: URLS.v1.WORKSHOP_PURCHASE_ORDERS,
        icon: IconFileText,
        roles: ["superadmin", "admin_mekanik"],
      },
      {
        name: "Purchase Receipts",
        href: URLS.v1.WORKSHOP_PURCHASE_RECEIPTS,
        icon: IconReceipt,
        roles: ["superadmin", "admin_mekanik"],
      },
      {
        name: "Service Reports",
        href: URLS.v1.WORKSHOP_SERVICE_REPORTS,
        icon: IconReportAnalytics,
        roles: ["superadmin", "mekanik"],
      },
      {
        name: "Stock Transfers",
        href: URLS.v1.WORKSHOP_STOCK_TRANSFERS,
        icon: IconGitMerge,
        roles: ["superadmin", "admin_mekanik"],
      },
    ],
  },

  // HR
  {
    name: "HR",
    icon: IconUsersGroup,
    roles: ["superadmin", "hr"], // Hanya Super Admin yang bisa melihat
    child: [
      {
        name: "Home",
        href: URLS.v1.HR_HOME,
        icon: IconLayoutDashboardFilled,
        roles: ["superadmin", "hr"],
      },
      {
        name: "Tutorial",
        href: URLS.v1.HR_TUTORIAL,
        icon: IconFileText,
        roles: ["superadmin", "hr"],
      },
      {
        name: "Manage",
        href: URLS.v1.HR_MANAGE,
        icon: IconSettings,
        roles: ["superadmin", "hr"],
      },
      {
        name: "Master",
        href: URLS.v1.HR_MASTER,
        icon: IconSettings2,
        roles: ["superadmin", "hr"],
      },
      {
        name: "Setting",
        href: URLS.v1.HR_SETTING,
        icon: IconSettings,
        roles: ["superadmin", "hr"],
      },
      {
        name: "Report",
        href: URLS.v1.HR_REPORT,
        icon: IconReport,
        roles: ["superadmin", "hr"],
      },
    ],
  },

  {
    name: "Master Data",
    icon: IconUsers,
    roles: ["superadmin", "admin", "reservation"], // Hanya Super Admin dan Admin yang bisa melihat
    child: [
      {
        name: "Customers",
        href: URLS.v1.CUSTOMERS,
        icon: IconUsers,
        roles: ["superadmin", "admin", "reservation"],
      },
      {
        name: "Agents",
        href: URLS.v1.AGENTS,
        icon: IconUsersGroup,
        roles: ["superadmin", "admin", "reservation"],
      },
      {
        name: "Master Keep",
        href: URLS.v1.MASTER_KEEP,
        icon: IconUsersGroup,
        roles: ["superadmin", "accounting"],
      },
      {
        name: "Guide",
        href: URLS.v1.GUIDE,
        icon: IconUsersGroup,
        roles: ["superadmin", "admin"],
      },
      {
        name: "Photographer",
        href: URLS.v1.PHOTOGRAPHER,
        icon: IconUsersGroup,
        roles: ["superadmin", "admin", "reservation"],
      },
      {
        name: "Labels",
        href: URLS.v1.LABELS,
        icon: IconTags,
        roles: ["superadmin", "reservation", "admin"],
      },
      {
        name: "Products",
        href: URLS.v1.PRODUCT,
        icon: IconShoppingCart,
        roles: ["superadmin", "admin"],
      },
      {
        name: "Trip",
        href: URLS.v1.TRIP,
        icon: IconGitMerge,
        roles: ["superadmin", "admin", "reservation"],
      },
      {
        name: "User",
        href: URLS.v1.USER,
        icon: IconUsers,
        roles: ["superadmin", "admin"],
      },
      {
        name: "Metode Pembayaran",
        href: URLS.v1.METODE_PEMBAYARAN,
        icon: IconCreditCard,
        roles: ["superadmin", "admin"],
      },
      {
        name: "Meal",
        href: URLS.v1.MEAL,
        icon: IconCreditCard,
        roles: ["superadmin", "admin", "reservation"],
      },
    ],
  },
  {
    name: "Resto",
    href: URLS.v1.INVOICES,
    icon: IconFileInvoice,
    roles: ["superadmin", "admin", "resto"], // Hanya Super Admin dan Admin yang bisa
    child: [
      {
        name: "POS",
        href: URLS.v1.POS,
        icon: IconFileInvoice,
        roles: ["superadmin", "admin", "resto"],
      },
      {
        name: "Transactions History",
        href: URLS.v1.TRANSACTIONS_HISTORY,
        icon: IconFileInvoice,
        roles: ["superadmin", "admin", "resto"],
      },
      {
        name: "Menu List",
        href: URLS.v1.PRODUCT_RESTO,
        icon: IconFileInvoice,
        roles: ["superadmin", "admin", "resto"],
      },
      {
        name: "Supplier",
        href: URLS.v1.SUPPLIER,
        icon: IconFileInvoice,
        roles: ["superadmin", "admin", "resto"],
      },
      {
        name: "Cashier History",
        href: URLS.v1.CASHIERHISTORY,
        icon: IconFileInvoice,
        roles: ["superadmin", "admin"],
      },
      {
        name: "Daily Report Resto",
        href: URLS.v1.DAILYREPORTRESTO,
        icon: IconFileInvoice,
        roles: ["superadmin", "admin", "resto"],
      },
    ],
  },
  {
    name: "Settings",
    icon: IconSettings,
    roles: ["superadmin"],
    child: [
      {
        name: "Roles",
        href: URLS.v1.ROLES,
        icon: IconShield,
        roles: ["superadmin"],
      },
      {
        name: "Permissions",
        href: URLS.v1.PERMISSIONS,
        icon: IconLock,
        roles: ["superadmin"],
      },
    ],
  },
  {
    name: "Pengaturan Aplikasi",
    href: URLS.v1.PENGATURAN_APLIKASI,
    icon: IconSettings2,
    roles: ["superadmin"],
  },
];
